module.exports = __webpack_public_path__ + "media/images/captive_portal/Advertisement-de91b4080446d13316f161029b96aa2b.svg";